export const SALARY_TYPE = {
    MONTHLY: 'MONTHLY',
    PER_TRIP: 'PER_TRIP',
    NOT_APPLICABLE: 'NONE'
}


// WEBPACK FOOTER //
// ./src/app/contants/SALARY_TYPE.ts